var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Not Found")]),_c('b-button',{attrs:{"variant":"secondary"},on:{"click":function($event){return _vm.goToHome()}}},[_vm._v("Home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }